import { apis } from 'ui-common'

export default {
  getIntolerances: () => apis.$get('/intolerances')
}
